import React, { useState } from 'react';
import { Menu, X, Github, Linkedin, Mail } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigation = [
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Projects', href: '#projects' },
    { name: 'Education', href: '#education' },
    { name: 'Blog', href: '#blog' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <header className="fixed top-0 w-full z-50 glass-header">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo with glass effect */}
          <div className="flex items-center">
            <div className="text-xl font-bold text-white relative">
              <span className="relative z-10">
                Arjun <span className="text-[rgb(218,255,1)]">Bhusal</span>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgb(218,255,1)] to-transparent opacity-20 blur-sm"></div>
            </div>
          </div>

          {/* Desktop Navigation with glass effect */}
          <nav className="hidden md:flex items-center space-x-2">
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="relative px-4 py-2 text-[rgb(218,218,218)] hover:text-[rgb(218,255,1)] transition-all duration-300 font-medium rounded-lg hover:bg-[rgba(218,255,1,0.1)] hover:backdrop-filter hover:backdrop-blur-sm group"
              >
                <span className="relative z-10">{item.name}</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(218,255,1,0.1)] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
              </button>
            ))}
          </nav>

          {/* Social Links - Desktop with enhanced glass effect */}
          <div className="hidden md:flex items-center space-x-3">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="glass-light w-10 h-10 rounded-xl flex items-center justify-center text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] hover:border-[rgba(218,255,1,0.3)] transition-all duration-300 hover:shadow-[0_0_20px_rgba(218,255,1,0.2)]"
            >
              <Github size={18} />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="glass-light w-10 h-10 rounded-xl flex items-center justify-center text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] hover:border-[rgba(218,255,1,0.3)] transition-all duration-300 hover:shadow-[0_0_20px_rgba(218,255,1,0.2)]"
            >
              <Linkedin size={18} />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              className="glass-light w-10 h-10 rounded-xl flex items-center justify-center text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] hover:border-[rgba(218,255,1,0.3)] transition-all duration-300 hover:shadow-[0_0_20px_rgba(218,255,1,0.2)]"
            >
              <Mail size={18} />
            </a>
          </div>

          {/* Mobile menu button with glass effect */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="glass-light w-10 h-10 rounded-xl flex items-center justify-center text-[rgb(218,218,218)] hover:text-[rgb(218,255,1)] transition-all duration-300"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation with glass effect */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-[rgba(255,255,255,0.1)] glass backdrop-blur-md mt-2 rounded-2xl mx-2">
            <nav className="flex flex-col space-y-2 px-4">
              {navigation.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className="text-[rgb(218,218,218)] hover:text-[rgb(218,255,1)] transition-all duration-300 font-medium text-left py-3 px-4 rounded-lg hover:bg-[rgba(218,255,1,0.1)] hover:backdrop-filter hover:backdrop-blur-sm"
                >
                  {item.name}
                </button>
              ))}
              <div className="flex items-center space-x-3 pt-4 border-t border-[rgba(255,255,255,0.1)] px-4">
                <a
                  href={personalInfo.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="glass-light w-10 h-10 rounded-xl flex items-center justify-center text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] hover:border-[rgba(218,255,1,0.3)] transition-all duration-300"
                >
                  <Github size={18} />
                </a>
                <a
                  href={personalInfo.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="glass-light w-10 h-10 rounded-xl flex items-center justify-center text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] hover:border-[rgba(218,255,1,0.3)] transition-all duration-300"
                >
                  <Linkedin size={18} />
                </a>
                <a
                  href={`mailto:${personalInfo.email}`}
                  className="glass-light w-10 h-10 rounded-xl flex items-center justify-center text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] hover:border-[rgba(218,255,1,0.3)] transition-all duration-300"
                >
                  <Mail size={18} />
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;